<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">PO List Price
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
              <b-form-input v-model="model.partnumber" placeholder="Item Code" readonly></b-form-input>
              <b-form-input v-model="model.itemname" placeholder="Item Name/Description/Spek" style="width:45% !important; margin-left:2px;"></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuItemShow=true" >
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-button class="ml-1 btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <b-row >
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
              <b-form-input v-model="model.tgl1" type="date" v-b-tooltip.hover title="optional (EMPTYallowed)"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="model.tgl2" type="date" v-b-tooltip.hover title="optional (EMPTYallowed)"></b-form-input>
              <b-input-group-prepend><b-button class="ml-1 btn btn-secondary" @click="clearDate()" > clear</b-button></b-input-group-prepend>
            </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
          <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="nomor">PO Number</b-form-checkbox>
                      <b-form-checkbox value="matauang">Currency</b-form-checkbox>
                      <b-form-checkbox value="paymterm">Payment Term</b-form-checkbox>
                      <b-form-checkbox value="locationdeliv">Location Delivery </b-form-checkbox>
                      <b-form-checkbox value="vendorinfo">Vendor/Supplier </b-form-checkbox>
                      <b-form-checkbox value="itemname">Item Name.</b-form-checkbox>
                      <b-form-checkbox value="description">Item Desc./Spec.</b-form-checkbox>
                      <b-form-checkbox value="description">PO Remark</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(orderdate)="data">
                  {{ data.item.orderdate | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
              <!-- <template v-slot:cell(itemname)="data">
                {{ data.item.itemname }}
                <pre>{{data.item.description}}</pre>
              </template> -->
              <template v-slot:cell(description)="data">
                <pre style="white-space: pre-wrap;">{{data.item.description}}</pre>
              </template>

                <template v-slot:cell(unitprice)="data">
                      {{ data.item.unitprice | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col lg="9">
                    <b-row >
                      <b-col cols="2">            
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="10">
                        <div style="display: flex;margin:0;padding:0;">
                            <div style="margin:0;padding:5px;width:500px; text-align:right;">
                                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                                to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                                of {{tblLcy.total}} entries,   <span class="mr-1">limit per page :</span> 
                                <select  v-model="tblLcy.limit"  style="width:60px;">
                                  <option>10</option>
                                  <option>15</option>
                                  <option>20</option>                            
                                  <option>25</option>
                                  <option>30</option>                            
                                  <option>40</option>                            
                                  <option>50</option>                            
                                  <option>60</option>                            
                                  <option>70</option>                            
                                  <option>80</option>                            
                                  <option>90</option>                            
                                </select>
                            </div>
                            <div>
                                <b-pagination  class="ml-1" 
                                  align="left"
                                  :total-rows="tblLcy.total"
                                  :per-page="tblLcy.limit"
                                  v-model="tblLcy.page"
                                ></b-pagination>
                            </div>
                        </div>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="3">
                        <!-- <b-input-group >
                            <b-input-group-prepend><label >Total Balance (LCY)</label></b-input-group-prepend>
                            <my-number class="form-control text-right mr-5" v-model="outstandLcy" :precision="2" disabled></my-number>
                        </b-input-group> -->
                </b-col>
            </b-row>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
        <lku-item @click="onSelectLkuItem"  :formdata="itemList" ></lku-item>
    </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
 
</style>

<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuItem from "../lookup/lkuItemLazzy";
import procure from "../../apis/procure";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      lkuItemShow: false,
      itemList:{},
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {itemno:'', partnumber:'',itemname:'',tgl1:'',tgl2:''},
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      outstandLcy:0,
      rptLines : [],
      subtotal : {},
      filterShow:'Show',
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "orderno",
            label: "Order Number",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Order Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "description",
            label: "Item Description",
            thStyle: "max-width:600px",
            tdStyle: "max-width:600px",
          },
          {
            key: "quantity",
            label: "Qty",
            thStyle: "width:50px",
            sortable: true
          },
          {
            key: "unitsize",
            label: "Unit",
            thStyle: "width:50px",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "unitprice",
            label: "Unit Price",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "kenappn",
            thStyle: "width:40px",
            label: "VAT",
            sortable: true
          },
          {
            key: "paymterm",
            thStyle: "width:100px",
            label: "T.O.P",
            sortable: true
          },
          {
            key: "locationdeliv",
            label: "Location Delivery",
            sortable: true
          },
          {
            key: "remark",
            label: "PO Remark",
            sortable: true
          },
        ]
      },
      filter: null,
      filterOn: [],   
    };
  },
  components: {Loading, myNumber, lkuItem},
  // computed: {
    // invalidFilter() {
    //   this.$v.model.$touch();
    //   return this.$v.model.$invalid;
    // },
  //   account() {
  //       return this.model.account;
  //   },
  // },
  // watch:{
  //   account: function(newval) {
  //     const obj=this.accounts.find(d => d.value === newval);
  //       this.model.namaacc=obj.text || '';
  //       this.model.kodeacc=obj.kodeacc;
  //       // console.log(`${this.model.account} | ${this.model.namaacc}`);
  //   },
    // showSummary : function(newval) {
    //     if (newval===true) {
    //         if (this.model.tabIndex === 0) {
    //           this.model.view = 'Summary in Original Currency';
    //         } else {
    //           this.model.view = 'Summary in Local Currency';
    //         }
    //     } else {
    //       this.model.view= 'Detail Invoice Outstanding';
    //     }        
    // },   
  // },  
  created: async function(){
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').subtract(6,'M').startOf('year').format('YYYY-MM-DD');
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblLcy.fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

  },  
  methods: {
    onSelectLkuItem(lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.model.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.model.partnumber = lkuData.selected.partnumber;
        this.model.itemno = lkuData.selected.itemno;
        this.model.itemname = lkuData.selected.itemname;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalBank_in = filteredItems.reduce((a, b) => a + b.bank_in, 0);
      // this.totalBank_out = filteredItems.reduce((a, b) => a + b.bank_out, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    clearDate() {
      this.model.tgl1='';
      this.model.tgl2='';
    },
    getData: async function(ctx) {
            try {
                this.isLoading=true;
                const result = await procure.hargapo(this.model);
                this.rptLines =  result[0];
                this.subtotal = result[1][0];
                this.tblLcy.total = this.rptLines.length;       
                this.isLoading=false;      
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await procure.hargapoexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR',10000);
            }
        }
      }
    },  
    close(){
          router.push("/receivable/home");
    }
  }
};
</script>
